import { createReducer } from "@reduxjs/toolkit";
import {
  rankingsFailure,
  rankingsRequest,
  rankingsSuccess,
  rankingsByPeriodRequest,
  rankingsByPeriodSuccess,
  rankingsByPeriodFailure,
  rankingsTournamentsRequest,
  rankingsTournamentsSuccess,
  rankingsTournamentsFailure,
} from "./rankingsActions";

export type RankingItem = {
  id: string;
  username: string;
  level: number;
  totalChips: number;
  exp: number;
  avatarFileId?: string | null;
  weeklyTournamentPoints?: number;
};

type RankingState = {
  loading: boolean;
  items: RankingItem[];
  period?: "Daily" | "Weekly" | "Monthly";
  total: number;
  error?: string;
  mode: "general" | "byPeriod" | "tournaments";
  tournamentEndAt: string | null;
  tournamentNow: string | null;
  tournamentReward: number;
  tournamentPersonal: any | null;
};

const initial: RankingState = {
  loading: false,
  items: [],
  total: 0,
  mode: "general",
  tournamentEndAt: null,
  tournamentNow: null,
  tournamentReward: 0,
  tournamentPersonal: null,
};

export const rankingsReducer = createReducer(initial, (b) => {
  b.addCase(rankingsRequest, (s) => {
    s.loading = true;
    s.error = undefined;
  });
  b.addCase(rankingsSuccess, (s, a) => {
    s.loading = false;
    s.items = a.payload.items;
    s.total = a.payload.total;
  });
  b.addCase(rankingsFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
  });
  b.addCase(rankingsByPeriodRequest, (s, a) => {
    s.loading = true;
    s.error = undefined;
    s.period = a.payload.period;
  });
  b.addCase(rankingsByPeriodSuccess, (s, a) => {
    s.loading = false;
    s.items = a.payload.items;
    s.period = a.payload.period;
  });
  b.addCase(rankingsByPeriodFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
  });
  b.addCase(rankingsTournamentsRequest, (s) => {
    s.loading = true;
    s.mode = "tournaments";
  });
  b.addCase(rankingsTournamentsSuccess, (s, a) => {
    s.loading = false;
    s.items = a.payload.items;
    s.tournamentEndAt = a.payload.endAt;
    s.tournamentNow = a.payload.now;
  });
  b.addCase(rankingsTournamentsFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
    s.tournamentEndAt = null;
  });
});

export const selectRankItems = (s: any) => s.rankings.items;
export const selectRankLoading = (s: any) => s.rankings.loading;
export const selectRankError = (s: any) => s.rankings.error;
export const selectRankTotal = (s: any) => s.rankings.total;
export const selectRankPeriod = (s: any) => s.rankings.period;
export const selectTournamentEndAt = (s: any) => s.rankings.tournamentEndAt;
export const selectTournamentNow = (s: any) => s.rankings.tournamentNow;
